// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"be763092","162":"8394701d","1824":"c38d1eab","6451":"9d4dbc3a","7242":"90f2abe3","8122":"185ad10a","8908":"9ef3d479","9576":"43240465"}[chunkId] + ".chunk.css";
};